import http from '../../utils/fetch';
export default {

    baseurl:'/api/select/wuliao',
    tejiaurl:'/api/select/tejia/wuliao',
    fwurl:'/api/select/fwwuliao',

    selectPage(q){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: q
        });
    },
    selectDbPage(q) {
        return http({
            url: this.baseurl+'/selectDbPage',
            method: 'post',
            params: q
        });
    },
    selectPrototypePage(q) {
        return http({
            url: this.baseurl+'/selectPrototypePage',
            method: 'post',
            params: q
        });
    },
    //上海物料选择
    selectshanghPage(q){
        return http({
            url: '/api/select/wuliaoshangh/selectPage',
            method: 'post',
            params: q
        });
    },
    selecttejiaPage(q){
        return http({
            url: this.tejiaurl+'/selectPage',
            method: 'post',
            params: q
        });
    },
    selecttejianewPage(q){
        return http({
            url: this.tejiaurl+'/selectnewPage',
            method: 'post',
            params: q
        });
    },
    //项目选择物料f
    wuliaoxm(q){
        return http({
            url: '/api/select/wuliaoxm/selectPage',
            method: 'post',
            params: q
        });
    },
    //项目选择物料f
    wuliaoxmother(q){
        return http({
            url: '/api/select/wuliaoxm/selectOtherPage',
            method: 'post',
            params: q
        });
    },
    selectWxPage(q){
        return http({
            url: '/api/select/wxwuliao/selectPage',
            method: 'post',
            params: q
        });
    },
    selectUsaPage(q){
        return http({
            url: '/api/select/wxwuliao/selectUsaPage',
            method: 'post',
            params: q
        });
    },
    //查询发货计划f
    selectFhPage(q){
        return http({
            url: '/api/swyl/v1/demo/viewOrder/selectOrderInfo',
            method: 'post',
            params: q
        });
    },
    checkOrderInfo(q){
        return http({
            url: '/api/swyl/v1/dingdmain/shipmentSchedule/checkOrderInfo',
            method: 'post',
            params: q
        });
    },
    selectInfoByList(q){
        return http({
            url: '/api/swyl/v1/dingdmain/carApplication/selectInfoByList?shipmentNum='+q,
            method: 'post',
        });
    },
    checkInfoByList(q){
        return http({
            url: '/api/swyl/v1/dingdmain/carApplication/checkInfoByList',
            method: 'post',
            params: q
        });
    },
    selectWmPage(q){
        return http({
            url: '/api/select/wmwuliao/selectPage',
            method: 'post',
            params: q
        });
    },
	selectTaojiPage(q){
		return http({
		    url: '/api/swyl/v1/order/bscOrderProductGroup/selectPage',
		    method: 'post',
		    params: q
		});
	},

    //查询OEM物料
    selectOEMPage(q){
        return http({
            url: '/api/swyl/v1/hetong/bscContractCgProduct/selectOEMPage',
            method: 'post',
            params: q
        });
    },

    //查询服务物料
    selectFwPage(q){
        return http({
            url: this.fwurl+'/selectPage',
            method: 'post',
            params: q
        });
    },
    selectOrderThList(q){
        return http({
            url: '/api/select/wuliao/selectOrderThListPage',
            method: 'post',
            params: q
        });
    },
    selectOrderTh(sapCode){
        return http({
            url: '/api/select/wuliao/selectOrderTh?sapCode='+sapCode,
            method: 'post',
        });
    },

}
